module.exports = __webpack_public_path__ + "img/item_CommIllustration_05c.a1b4423f.jpeg";